import { render, staticRenderFns } from "./SlideOver.vue?vue&type=template&id=63c20aec"
import script from "./SlideOver.vue?vue&type=script&setup=true&lang=ts"
export * from "./SlideOver.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports